/**
 * Admin sidebar navigation
 */

import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  BriefcaseIcon,
  DocumentTextIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';

const navItems = [
  { name: 'Dashboard', path: '/admin', icon: HomeIcon, exact: true },
  { name: 'Jobs', path: '/admin/jobs', icon: BriefcaseIcon },
  { name: 'Logs', path: '/admin/logs', icon: DocumentTextIcon },
  { name: 'Settings', path: '/admin/settings', icon: Cog6ToothIcon },
];

export default function Sidebar() {
  const location = useLocation();

  return (
    <aside className="w-64 bg-dark-bg-secondary border-r border-gray-800 flex flex-col">
      {/* Sidebar header */}
      <div className="p-6 border-b border-gray-800">
        <h2 className="text-lg font-bold text-cyber-blue-500">Admin Panel</h2>
        <p className="text-sm text-gray-400 mt-1">System Management</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => {
          const isActive = item.exact
            ? location.pathname === item.path
            : location.pathname.startsWith(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition-all ${
                isActive
                  ? 'bg-cyber-blue-500 text-white shadow-glow-sm'
                  : 'text-gray-300 hover:bg-dark-bg-tertiary hover:text-white'
              }`}
            >
              <item.icon className="w-5 h-5" />
              <span>{item.name}</span>
            </Link>
          );
        })}
      </nav>

      {/* Sidebar footer */}
      <div className="p-4 border-t border-gray-800">
        <div className="px-4 py-3 bg-dark-bg-tertiary rounded-lg">
          <div className="text-xs text-gray-400 mb-1">System Status</div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
            <span className="text-sm font-medium text-green-400">Operational</span>
          </div>
        </div>
      </div>
    </aside>
  );
}
